<template lang="pug">
  v-expansion-panel-content(@input="headerClick" ref="content" :readonly="customToggle")
    template(#header="")
      div(@click="emitToggleEvent" tabindex="0" @keyup.enter="emitToggleEvent" class="m-accordion-content-box")
        slot(name="header")
          component(:is="parentIcon" v-if="parentIcon")
          span {{header}}

        slot(name="header-icons")

    template(#actions="")
      div(@click="emitToggleEvent")
        e-progress-accordion(v-if="loading")
        v-icon( v-else
        :class="isNav ? 'm-accordion-content__icon' : 'm-accordion-content__icon_large'"
          style="vertical-align: middle; transform: rotate(90deg)") {{ arrowIcon }}
    slot
</template>

<script>
export default {
  name: "m-accordion-dashboard-content",
  props: {
    header: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    customToggle: {
      type: Boolean,
      default: false
    },
    isNav: {
      type: Boolean,
      default: false
    },
    parentIcon: {
      type: String
    }
  },
  computed: {
    arrowIcon() {
      return this.isNav ? 'chevron_left' : 'arrow_back_ios';
    }
  },
  methods: {
    headerClick(isOpen) {
      if (isOpen) {
        this.$emit('content:opened');
      } else {
        this.$emit('content:closed')
      }
    },
    toggle() {
      this.$refs.content.expansionPanel.panelClick(this.$refs.content._uid);
    },
    emitToggleEvent() {
      this.$emit('content:toggle', {'type': this.$refs.content.isActive ? 'close' : 'open'})
    }
  }
}
</script>

<style lang="scss" scoped>
.v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {
  transform: rotate(-90deg) !important;
}

.app-layout__auth .v-expansion-panel__container {
  box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
  border-radius: 3px;
  margin-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

.m-accordion-content-box {
  outline: none;
  padding: 1rem 0 1rem 0;

  .v-icon {
    margin-right: 10px;
    transform: translateY(-3px);
  }

  &:focus {
    border-bottom: 2px solid var(--v-primary-base);
  }
}

.v-expansion-panel__header__icon {
  .m-accordion-content__icon {
    font-size: 28px;
    color: var(--v-secondary-darken2) !important;
  }
}

.m-accordion-content {
  &__icon {
    &_large {
      width: 28px !important;
      height: 28px !important;
      padding-left: 7px;


      @include updatedMedia(sm) {
        width: 28px !important;
        height: 28px !important;
      }
    }
  }
}
</style>
<style lang="scss">
.m-accordion-dashboard {
  .v-expansion-panel__container {
    .e-link-nav {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;

      .effectiveness--name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    .effectiveness {
      .m-block-object-actions__wrapper {
        display: none;

        @media (max-width: $md) {
          display: block;
        }
      }
    }

    .e-typography-heading-3 {
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      font-size: 1.1rem !important;
    }
  }
}
</style>